import { FC, SVGAttributes } from "react";

interface Props {
  colors?: string[];
  width?: number;
}

export const Przelewy24Icon: FC<SVGAttributes<SVGSVGElement> & Props> = ({
  colors = ["#D13239", "#B3B2B1"],
  width = 96,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height="40"
      viewBox={`0 0 ${width} 40`}
      {...props}
    >
      <title>Icons/Payment &amp; Trust/Przelewy24</title>
      <g
        id="Icons/Payment-&amp;-Trust/Przelewy24"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Group" transform="translate(12.000000, 8.000000)">
          <polygon
            id="Path"
            fill={colors[0]}
            points="14.91 13.83375 20.775 13.82625 20.56125 15.16125 15.65625 19.845 19.77375 19.8375 19.53375 21.2775 13.47 21.28125 13.725 19.7925 18.4275 15.28875 14.67375 15.28875"
          />
          <path
            d="M8.49375,11.55 C8.36625,11.415 8.1825,11.31 7.98,11.2275 C7.76625,11.145 7.53,11.085 7.2975,11.04375 C7.005,10.99125 6.72,10.96875 6.5175,10.96125 C6.33,10.95375 6.21,10.95375 6.21,10.95375 L3.645,10.95375 L1.73625,10.95375 L0.02625,21.28125 L1.62375,21.28125 L2.25375,17.45625 L5.35125,17.47125 C5.35125,17.47125 6.55875,17.52 7.41375,17.06625 C8.26875,16.6125 8.4975,15.58125 8.4975,15.58125 C8.4975,15.58125 8.59125,15.19875 8.67,14.73375 C8.75625,14.22 8.8425,13.605 8.8875,13.27875 C8.90625,13.13625 8.9175,13.04625 8.9175,13.04625 C8.9175,13.04625 8.94,12.94125 8.94,12.77625 C8.94375,12.5475 8.91,12.2025 8.73,11.8725 C8.66625,11.75625 8.59125,11.65125 8.49375,11.55 Z M7.26375,13.3725 C7.26375,13.39125 7.12125,14.22 6.93375,15.2025 C6.8625,15.5775 6.57375,15.78 6.24375,15.85125 C5.69625,15.9675 5.1075,15.945 5.1075,15.945 L2.52,15.9375 L3.09,12.50625 L5.43375,12.51375 C5.43375,12.51375 5.59125,12.51 5.8125,12.51375 C6.06375,12.5175 6.3975,12.52875 6.67125,12.56625 C6.9075,12.59625 7.095,12.645 7.155,12.72 C7.23375,12.8175 7.26375,12.945 7.275,13.0575 C7.29,13.2225 7.26375,13.36125 7.26375,13.3725 Z"
            id="Shape"
            fill={colors[0]}
          />
          <polygon
            id="Path"
            fill={colors[0]}
            points="28.72875 10.95375 30.26625 10.95375 28.545 21.28125 27.00375 21.2775"
          />
          <polygon
            id="Path"
            fill={colors[0]}
            points="36.93375 13.83375 38.4075 13.83 38.92875 19.0725 41.1975 13.8225 43.01625 13.82625 43.5525 19.09125 45.8175 13.83 47.3475 13.83 44.1 21.27375 42.285 21.27375 41.76 16.06125 39.46875 21.27375 37.68375 21.28125"
          />
          <g
            transform="translate(20.137500, 13.725000)"
            fill={colors[0]}
            fillRule="nonzero"
          >
            <path
              d="M5.7525,0.16875 C5.32125,0.03 4.575,1.04960311e-13 3.94125,0.0075 C3.33,0.015 3.04875,0.045 2.82,0.09375 C2.82,0.09375 1.7325,0.25125 1.11375,1.01625 C0.495,1.78125 0.31125,3.45375 0.31125,3.45375 C0.31125,3.45375 -0.05625,5.3025 0.0525,5.92125 C0.16125,6.53625 0.3525,7.11 1.05,7.37625 C1.7475,7.64625 2.34,7.63125 2.34,7.63125 C2.34,7.63125 3.585,7.72875 4.5225,7.5075 C5.46,7.28625 5.955,6.62625 5.955,6.62625 C5.955,6.62625 6.17625,6.34125 6.33375,6.00375 C6.49125,5.66625 6.54,5.43 6.5475,5.4 L6.645,4.99875 L5.05125,5.0025 C5.05125,5.0025 4.965,6.05625 4.1025,6.15375 C3.24375,6.25125 2.7825,6.21375 2.61375,6.20625 C2.44875,6.19875 1.52625,6.24 1.60125,5.4675 C1.60125,5.45625 1.60125,5.44125 1.605,5.41875 C1.64625,4.54125 1.74375,4.3125 1.74375,4.3125 L6.75,4.2975 L6.96375,3.06 C7.21125,1.6575 7.035,0.58875 5.7525,0.16875 Z M5.41875,2.88375 L1.9875,2.88 L2.1225,2.33625 C2.1225,2.33625 2.2425,1.90875 2.47875,1.72875 C2.71875,1.54875 3.0225,1.515 3.3075,1.48875 C3.5925,1.4625 4.35375,1.40625 4.9725,1.53375 C5.17875,1.575 5.37375,1.69125 5.42625,1.86375 C5.54625,2.26875 5.41875,2.88375 5.41875,2.88375 Z"
              id="Shape"
            />
            <path
              d="M1.64775,5.43384231 C1.64775,5.45490159 1.63775,5.47596088 1.63775,5.49702016 C1.62775,5.60933632 1.64775,5.42682255 1.64775,5.43384231 Z"
              id="Path"
            />
          </g>
          <g
            transform="translate(29.587500, 13.725000)"
            fill={colors[0]}
            fillRule="nonzero"
          >
            <path
              d="M1.639375,5.43759231 C1.639375,5.45865159 1.629375,5.47971088 1.629375,5.50077016 C1.629375,5.61308632 1.639375,5.43057255 1.639375,5.43759231 Z"
              id="Path"
            />
            <path
              d="M5.74875,0.1725 C5.3175,0.03375 4.57125,0.00375 3.9375,0.01125 C3.32625,0.01875 3.045,0.04875 2.81625,0.0975 C2.81625,0.0975 1.72875,0.255 1.11,1.02 C0.49125,1.785 0.3075,3.4575 0.3075,3.4575 C0.3075,3.4575 -0.06,5.30625 0.04875,5.925 C0.1575,6.54 0.34875,7.11375 1.04625,7.38 C1.74375,7.65 2.33625,7.635 2.33625,7.635 C2.33625,7.635 3.58125,7.7325 4.51875,7.51125 C5.45625,7.29 5.95125,6.63 5.95125,6.63 C5.95125,6.63 6.1725,6.345 6.33,6.0075 C6.4875,5.67 6.53625,5.43375 6.54375,5.40375 L6.64125,5.0025 L5.0475,5.00625 C5.0475,5.00625 4.96125,6.06 4.09875,6.1575 C3.24,6.255 2.77875,6.2175 2.61,6.21375 C2.445,6.20625 1.5225,6.24375 1.5975,5.475 C1.5975,5.46375 1.5975,5.44875 1.60125,5.42625 C1.6425,4.54875 1.74,4.32 1.74,4.32 L6.74625,4.305 L6.96,3.0675 C7.2075,1.66125 7.03125,0.58875 5.74875,0.1725 Z M5.4,2.88375 L1.96875,2.88 L2.10375,2.33625 C2.10375,2.33625 2.22375,1.90875 2.46,1.72875 C2.69625,1.54875 3.00375,1.515 3.28875,1.48875 C3.57375,1.4625 4.335,1.40625 4.95375,1.53375 C5.16,1.575 5.355,1.69125 5.4075,1.86375 C5.5275,2.265 5.4,2.88375 5.4,2.88375 Z"
              id="Shape"
            />
          </g>
          <path
            d="M49.1175,13.83375 L50.10375,19.27875 L52.89,13.83 L54.4575,13.845 L50.44125,21.62625 C50.44125,21.62625 49.71375,23.03625 49.26375,23.3925 C48.81375,23.74875 48.53625,23.91 48.16875,23.9475 C47.80125,23.985 47.65125,24.01125 47.29875,23.9475 L46.92375,23.88 L47.15625,22.48875 C47.15625,22.48875 47.77875,22.605 48.14625,22.45875 C48.5175,22.3125 48.81375,21.6825 48.81375,21.6825 L49.00125,21.3675 L47.55,13.83 L49.1175,13.83375 L49.1175,13.83375 Z"
            id="Path"
            fill={colors[0]}
          />
          <path
            d="M55.0275,14.5725 L56.64375,14.57625 L56.74125,13.95 C56.74125,13.95 56.91375,12.8175 57.3,12.6 C57.42375,12.52875 57.6225,12.465 57.85125,12.42375 C58.275,12.34875 58.81125,12.34125 59.25,12.35625 C59.92125,12.37875 60.17625,12.38625 60.85875,12.465 C61.54125,12.54375 61.36875,13.20375 61.36875,13.20375 L61.23375,14.19 C61.23375,14.19 61.17375,14.6325 61.01625,14.90625 C60.8775,15.15 60.495,15.315 60.27375,15.38625 C59.74125,15.55875 57.91875,16.02375 57.91875,16.02375 L56.48625,16.43625 C56.48625,16.43625 55.605,16.69125 55.11375,17.235 C54.61875,17.7825 54.42375,18.40125 54.35625,18.72375 C54.28875,19.04625 53.91,21.2775 53.91,21.2775 L61.6425,21.28125 L61.90125,19.73625 L55.785,19.74375 L55.89375,19.11375 C55.89375,19.11375 55.965,18.465 56.2275,18.25125 C56.31,18.18375 56.35125,18.09375 56.83875,17.92125 C57.13125,17.81625 58.12875,17.55 58.12875,17.55 L60.435,16.92 C60.435,16.92 61.695,16.5975 62.19,15.9075 C62.685,15.22125 62.87625,13.905 62.87625,13.905 C62.87625,13.905 63.01125,12.62625 62.90625,12.225 C62.805,11.82375 62.42625,11.34375 61.965,11.1375 C61.50375,10.93125 61.02375,10.81125 59.6325,10.83 C58.24125,10.84875 57.55125,10.9125 56.84625,11.175 C56.14125,11.43375 55.7325,11.90625 55.47375,12.57375 C55.1925,13.2075 55.0275,14.5725 55.0275,14.5725 L55.0275,14.5725 Z"
            id="Path"
            fill={colors[1]}
          />
          <path
            d="M69.585,17.445 L70.66875,10.95 L68.74875,10.95 L62.77125,17.37 L62.50125,18.9975 L67.72875,18.9975 L67.34625,21.2775 L68.95125,21.28125 L69.33,18.9975 L70.81125,19.00125 L71.0775,17.445 L69.585,17.445 Z M67.9875,17.44875 L64.60875,17.445 L68.7225,13.06125 L67.9875,17.44875 Z"
            id="Shape"
            fill={colors[1]}
          />
          <path
            d="M11.88375,11.805 L16.8075,11.805 C16.8075,11.805 17.91,10.9125 18.69375,10.33875 C19.4775,9.765 20.9025,8.86125 20.9025,8.86125 L18.12,7.56 C18.12,7.56 15.76875,9.015 14.77125,9.70125 C13.80375,10.335 11.88375,11.805 11.88375,11.805 L11.88375,11.805 Z"
            id="Path"
            fill={colors[1]}
          />
          <path
            d="M22.46625,7.9425 L20.1825,6.405 C20.1825,6.405 22.24875,5.23125 24.9975,4.13625 C27.7425,3.04125 29.20875,2.58375 29.20875,2.58375 L29.67375,4.7625 C29.67375,4.7625 27.03,5.6475 25.515,6.36375 C23.9475,7.03125 22.46625,7.9425 22.46625,7.9425 L22.46625,7.9425 Z"
            id="Path"
            fill={colors[1]}
          />
          <path
            d="M31.36125,4.28625 L30.96375,2.055 C30.96375,2.055 33.78375,1.305 36.36375,0.825 C38.9475,0.345 42.37125,0.11625 42.37125,0.11625 L41.23875,3.5625 C41.23875,3.5625 38.2275,3.15 35.4,3.53625 C33.19875,3.79875 31.36125,4.28625 31.36125,4.28625 L31.36125,4.28625 Z"
            id="Path"
            fill={colors[1]}
          />
          <path
            d="M43.03125,3.855 L44.93625,0.02625 C44.93625,0.02625 49.11,-0.05625 52.71,0.5025 C56.31,1.0575 59.6025,1.9125 59.53125,1.95 L50.40375,6.72375 C50.40375,6.72375 48.27,5.37375 45.6225,4.545 C44.1225,4.1025 43.03125,3.855 43.03125,3.855 L43.03125,3.855 Z"
            id="Path"
            fill={colors[1]}
          />
          <path
            d="M52.03875,7.7625 L54.045,9.285 L70.53375,9.285 C70.53375,9.285 70.5,8.7525 70.06125,7.995 C69.7875,7.5225 69.28875,7.02 68.7675,6.49875 C68.57625,6.31125 67.81875,5.71875 67.24875,5.3475 C65.79375,4.4025 64.98,4.03875 63.46875,3.3525 L52.03875,7.7625 L52.03875,7.7625 Z"
            id="Path"
            fill={colors[1]}
          />
          <path
            d="M12.9525,13.82625 C12.33375,13.82625 11.74875,14.07 11.25,14.34375 L11.33625,13.82625 L9.6975,13.82625 L8.385,21.24 L10.0275,21.24 L10.755,17.13375 C10.905,16.30125 11.5275,15.27 12.7425,15.27 L13.59,15.26625 L13.845,13.82625 L12.9525,13.82625 Z"
            id="Path"
            fill={colors[0]}
            fillRule="nonzero"
          />
        </g>
      </g>
    </svg>
  );
};
